(function () {
	"use strict";

	// Fetch all the forms we want to apply custom Bootstrap validation styles to
	var forms = document.querySelectorAll(".needs-validation");

	// Loop over them and prevent submission
	Array.prototype.slice.call(forms).forEach(function (form) {
		form.addEventListener(
			"submit",
			function (event) {
				if (!form.checkValidity()) {
					event.preventDefault();
					event.stopPropagation();
				}
				form.classList.add("was-validated");
			},
			false
		);
	});
})();

function ScrollToContent() {
	jQuery("html, body")
		.stop()
		.animate(
			{
				scrollTop:
					jQuery("#content").offset().top -
					jQuery(".default-header").outerHeight(),
			},
			{ duration: 800, queue: !0 }
		)
		.queue(function () {
			jQuery(this).dequeue();
		});
}

jQuery(function ($) {
	$(".second-col").attr("data-aos", "fade-up");
	$(".second-col").attr("data-aos-duration", "1000");

	// makes the parallax elements
	function parallaxIt() {
		// create variables
		var $fwindow = $(window);
		var scrollTop =
			window.pageYOffset || document.documentElement.scrollTop;

		// on window scroll event
		$fwindow.on("scroll resize", function () {
			scrollTop =
				window.pageYOffset || document.documentElement.scrollTop;
		});

		// for each of content parallax element
		$('[data-type="content"]').each(function (index, e) {
			var $contentObj = $(this);
			var fgOffset = parseInt($contentObj.offset().top);
			var yPos;
			var speed = $contentObj.data("speed") || 1;

			$fwindow.on("scroll resize", function () {
				yPos = fgOffset - scrollTop / speed;

				$contentObj.css("top", yPos);
			});
		});

		// for each of background parallax element
		$('[data-type="background"]').each(function () {
			var $backgroundObj = $(this);
			var bgOffset = parseInt($backgroundObj.offset().top);
			var yPos;
			var coords;
			var speed = $backgroundObj.data("speed") || 0;

			$fwindow.on("scroll resize", function () {
				yPos = -((scrollTop - bgOffset) / speed);
				coords = "50% " + yPos + "px";

				$backgroundObj.css({ backgroundPosition: coords });
			});
		});

		// triggers winodw scroll for refresh
		$fwindow.trigger("scroll");
	}

	parallaxIt();

	// Add smoke
	if ($(".parallax-header").length > 0) {
		for (var i = 3; i > 0; i--) {
			$(".parallax-header .wp-block-cover").prepend(
				$('<div class="smoke" data-index="' + i + '"></div>')
			);
		}
	}
}); // jQuery End
